module.exports = __webpack_public_path__ + "static/cc-info-9a221b6312189f9500b6f6178f068441.jpg";